var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide-down","mode":"out-in"}},[(_vm.showMessages)?_c('chat-card',{staticClass:"chat-box-card",on:{"close":function($event){_vm.activator = false}}}):_vm._e()],1),_c('div',{staticClass:"chat-box-activator"},[(_vm.phone)?_c('a',{class:[
        'chat-box-activator-call',
        { hidden: _vm.showMessages } ],attrs:{"href":("tel:" + _vm.phone)}}):_vm._e(),_c('div',{class:[
        'pointer chat-box-activator-chat',
        { active: _vm.showMessages },
        {
          bgRed:
            _vm.sessionTimer >= 0 &&
            !_vm.showMessages &&
            _vm.user &&
            !_vm.sendQualityForAgent,
        } ],on:{"click":_vm.onInviteClick}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }